import { ServicePackageItem } from "@/models/api/administration/servicesAndAttributes/ServicePackageItem";

export class ServicePackageRootItem {
  serviceTypeId!: number | null;
  value!: number;
  subItemsFromSettings!: boolean;
  constructor() {
    this.serviceTypeId = null;
    this.value = 0;
    this.subItemsFromSettings = false;
  }

  static fromServicePackageItem(servicePackageItem: ServicePackageItem): ServicePackageRootItem {
    const servicePackageRootItem = new ServicePackageRootItem();
    servicePackageRootItem.serviceTypeId = servicePackageItem.serviceTypeId;
    servicePackageRootItem.value = servicePackageItem.amount;
    return servicePackageRootItem;
  }
}
